// import { Box, Flex, Icon, Text } from "@chakra-ui/react";
// import React from "react";
// import { FaArrowTrendDown, FaArrowTrendUp } from "react-icons/fa6";

// interface DashboardCardProps {
//   title: string;
//   value: number | string;
//   icon: React.ElementType;
//   iconBgColor?: string;
//   iconColor?: string;
//   trendValue?: any;
//   showTrend?: boolean;
//   iconBoxSize?: any; // 👈 new prop (optional)
// }

// export default function DashboardCard({
//   title,
//   value,
//   icon,
//   iconBgColor,
//   iconColor,
//   trendValue,
//   showTrend = true,
//   iconBoxSize,
// }: DashboardCardProps) {
//   const trendColor =
//     trendValue == 0.0 ? "blue.400" : trendValue > 0 ? "green.400" : "red.400";
//   const trendText =
//     trendValue > 0 ? "Up from yesterday" : "Down from yesterday";

//   return (
//     <Box
//       p={{ base: 3, md: 5 }}
//       rounded={"2xl"}
//       shadow={"md"}
//       borderWidth={1}
//       bg={"white"}
//     >
//       <Flex justify={"space-between"}>
//         <Box>
//           <Text
//             color={"gray"}
//             fontWeight={500}
//             fontSize={{ base: "sm", md: "md" }}
//           >
//             {title}
//           </Text>
//           <Text
//             fontSize={{ base: "2xl", md: "3xl" }}
//             fontWeight={500}
//             mt={{ base: 1, md: 2 }}
//           >
//             {(value === undefined || value === 0 || value === "₹ undefined")
//               ? "0"
//               : value}
//           </Text>
//         </Box>
//         <Icon
//           boxSize={iconBoxSize || { base: 10, md: 12 }}
//           color={iconColor}
//           as={icon}
//           bg={iconBgColor}
//           p={2}
//           rounded={"35%"}
//         />
//       </Flex>

//       {showTrend && (
//         <Flex align={"center"} mt={3} gap={{ base: 2, md: 3 }}>
//           <Icon
//             boxSize={{ base: 5, md: 6 }}
//             as={trendValue > 0 ? FaArrowTrendUp : FaArrowTrendDown}
//             color={trendColor}
//           />
//           <Text
//             color={trendColor}
//             fontWeight={500}
//             fontSize={{ base: "sm", md: "md" }}
//           >
//             {trendValue === "NaN" ? "0" : trendValue}%
//           </Text>
//           <Text
//             fontSize={{ base: "xs", md: "sm" }}
//             color={"gray"}
//             fontWeight={500}
//           >
//             {trendText}
//           </Text>
//         </Flex>
//       )}
//     </Box>
//   );
// }

import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import React from "react";

interface DashboardCardProps {
  title: string;
  value: number | string;
  icon: React.ElementType;
  iconBgColor?: string;
  iconColor?: string;
  trendValue?: number | string;
  showTrend?: boolean;
  iconBoxSize?: any;
}

export default function DashboardCard({
  title,
  value,
  icon,
  iconBgColor = "#edf5ff",
  iconColor = "#2f80ff",
  trendValue,
  showTrend = true,
}: DashboardCardProps) {
  const displayValue =
    value === undefined || value === 0 || value === "₹ undefined"
      ? "0"
      : value;

  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor="#d8e1ee"
      borderTop="4px solid"
      borderTopColor={iconColor}
      borderRadius="20px"
      boxShadow="0 18px 40px rgba(15, 23, 42, 0.08)"
      p={{ base: 4, lg: 5 }}
      minH="168px"
      transition="all 0.25s ease"
      _hover={{
        transform: "translateY(-3px)",
        boxShadow: "0 24px 50px rgba(15, 23, 42, 0.12)",
      }}
    >
      <Flex justify="space-between" align="flex-start" gap={4}>
        <Box>
          <Text
            fontSize="lg"
            fontWeight="600"
            color="#64748b"
            lineHeight="1.2"
          >
            {title}
          </Text>

          <Text
            mt={4}
            fontSize={{ base: "40px", lg: "44px" }}
            lineHeight="1"
            fontWeight="800"
            color="#0f172a"
          >
            {displayValue}
          </Text>
        </Box>

        <Flex
          w="48px"
          h="48px"
          borderRadius="14px"
          bg={iconBgColor}
          color={iconColor}
          align="center"
          justify="center"
          border="1px solid"
          borderColor="#e2e8f0"
          boxShadow="0 10px 24px rgba(148, 163, 184, 0.12)"
          flexShrink={0}
        >
          <Icon as={icon} boxSize={5} />
        </Flex>
      </Flex>

      {showTrend && (
        <Flex mt={6} align="center" gap={2} flexWrap="wrap">
          <Flex
            px={3}
            py={1}
            borderRadius="999px"
            bg={iconBgColor}
            color={iconColor}
            fontSize="xs"
            fontWeight="700"
            lineHeight="1"
            minH="28px"
            align="center"
            justify="center"
          >
            {trendValue === "NaN" || trendValue === undefined
              ? "0%"
              : `${trendValue}%`}
          </Flex>

          <Text
            fontSize="xs"
            fontWeight="600"
            color="#94a3b8"
          >
            from previous period
          </Text>
        </Flex>
      )}
    </Box>
  );
}